import React from 'react'

import { InputBool, Input, Icon } from './styles'
import toReduxFormBool from '../../../enhancers/ToReduxFormBool'

export const Component = ({
  id,
  input,
  inputType,
  iconName = 'checkmark',
  checked,
  handleChange,
  disabled,
  className,
  smallIcon,
  validator,
  meta: { error, submitFailed } = {},
  meta,
  ...otherProps
}) => (
  <InputBool
    checked={checked}
    type={inputType}
    disabled={disabled}
    className={className}
    error={error && submitFailed}
    data-testid={`${otherProps['data-testid']}_label`}
  >
    <Input
      id={id}
      {...input}
      type={inputType}
      disabled={disabled}
      data-heap-redact-text
      data-testid={otherProps['data-testid']}
      checked={checked}
      onChange={handleChange}
      validator={validator}
    />
    <Icon name={iconName} checked={checked} small={smallIcon} />
  </InputBool>
)

Component.displayName = 'InputBool'

export default toReduxFormBool(Component)
